/* eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'delete-category-info-popup',
  components: {},
  props: ['deletecategoryID'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    popupCloseMethod() {
      bus.$emit('removeCategoryPopupStateBus', false);
    },
    getCategoryAgain() {
      this.$store.dispatch('getCategoriesListAction')
    },
    removeConfirmationMethod() {
      let data = {
        id: this.deletecategoryID
      }
      this.$store.dispatch('deleteCategoryListById', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg || 'Category removed successfully');
            this.popupCloseMethod();
            this.getCategoryAgain();
          }
        })
    },

  }
}